import { render, staticRenderFns } from "./TemplateChatMember.vue?vue&type=template&id=2e52b5be&scoped=true&"
import script from "./TemplateChatMember.vue?vue&type=script&lang=js&"
export * from "./TemplateChatMember.vue?vue&type=script&lang=js&"
import style0 from "./TemplateChatMember.vue?vue&type=style&index=0&id=2e52b5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52b5be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VAvatar,VBadge,VBtn,VChip,VCol,VIcon,VRow,VVirtualScroll})
